var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.taskUserId && _vm.testId)?_c('BrandTest',{attrs:{"id":"divYapKazanQuizWrapper","taskUserId":_vm.taskUserId,"testId":_vm.testId}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }